import React from 'react'

import { Button, Spinner, useScreenClass } from '@vp/swan'
import { useLocalizations } from '@vp/ubik-localizations-provider'

import { useAppState } from '../root/contexts/AppContext'
import { useAddToCartAction } from '../../hooks/useAddToCartAction'

type AddToCartButtonProps = {
  disabled?: boolean
  widthVariant?: 'full-width' | 'standard'
}

const AddToCartButton: React.FC<AddToCartButtonProps> = (props) => {
  const { disabled = false, widthVariant = 'standard' } = props

  const { editSource } = useAppState()
  const { t } = useLocalizations()
  const { onAddToCartClick, isUpdatingCart } = useAddToCartAction()
  const screenClass = useScreenClass()

  return (
    <Button
      data-testid="qsp-cta"
      skin="primary"
      disabled={isUpdatingCart || disabled}
      onClick={onAddToCartClick}
      width={widthVariant}
      mx={screenClass === 'xs' ? '3' : '0'}
    >
      {isUpdatingCart && <Spinner accessibleText={t('loading-label')} />}
      {editSource ? t('update-cart') : t('add-to-cart')}
    </Button>
  )
}

export default AddToCartButton
